import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import { Controller } from "react-hook-form";
const ContactFormConsent = ({ control, showError, onResetError, }) => {
    return (_jsxs(FormControl, { error: showError("consent"), margin: "dense", sx: { mt: 1.5 }, children: [_jsx(Controller, { name: "consent", control: control, rules: { required: true }, render: ({ field }) => (_jsx(FormControlLabel, { control: _jsx(Checkbox, { ...field, id: "consent", checked: Boolean(field.value), onChange: (event) => {
                            onResetError();
                            field.onChange(event.target.checked);
                        }, slotProps: {
                            input: {
                                "aria-required": "true",
                                "aria-describedby": showError("consent")
                                    ? "consent-error"
                                    : undefined,
                            },
                        } }), label: _jsxs(_Fragment, { children: ["Les donn\u00E9es transmises dans le formulaire pourront \u00EAtre utilis\u00E9es par DOCAPOSTE pour vous contacter et vous adresser des communications de nature commerciale. Pour plus d'informations sur le traitement des donn\u00E9es, consultez notre", " ", _jsx("a", { href: "/politique-de-confidentialite", target: "_blank", rel: "noopener noreferrer", style: { textDecoration: "underline" }, children: "Politique de confidentialit\u00E9 et de protection des donn\u00E9es personnelles" }), "."] }), sx: {
                        ml: 0,
                        alignItems: "flex-start",
                        "& .MuiCheckbox-root": {
                            color: showError("consent") ? "error.main" : undefined,
                        },
                        "&:not(.Mui-disabled):hover .MuiCheckbox-root:not(.Mui-checked)": {
                            borderColor: showError("consent")
                                ? "error.main"
                                : "primary.main",
                        },
                        "& .MuiFormControlLabel-label": {
                            flex: 1,
                            fontSize: "14px",
                        },
                        "& .MuiFormControlLabel-label a": {
                            textDecoration: "underline",
                        },
                        "& .MuiFormControlLabel-label a:hover": {
                            textDecorationThickness: "2px",
                        },
                        "& .MuiFormControlLabel-label a:focus-visible": {
                            outline: "2px solid",
                            outlineColor: "secondary.main",
                            outlineOffset: "2px",
                        },
                    } })) }), showError("consent") && (_jsx(FormHelperText, { id: "consent-error", role: "alert", children: "Vous devez accepter les conditions ci-dessus pour continuer" }))] }));
};
export default ContactFormConsent;
